import { createAction, props } from '@ngrx/store';
import { TraineeInvite } from '../../models/trainee-invite.model';
import { TraineeAdapted } from '../../models/trainee-list.model';

export const loadTraineeManagement = createAction('[Trainee Page] Page Load');

export const saveNewTraineeInvite = createAction(
  '[Trainee Page] Save Trainee Invite Details',
  props<{ traineeDetails: TraineeInvite }>(),
);
export const navigateToInviteTrainee = createAction(
  '[Trainee Page] Navigate to Invite Trainee',
);

export const backToTraineeManagement = createAction(
  '[Trainee Page] Navigate Back to Trainee Management',
);

export const filterTrainees = createAction(
  '[Trainee Page] Filter Trainees',
  props<{ searchFilter: string }>(),
);

export const editTrainee = createAction(
  '[Trainee Page] Edit Trainee',
  props<{ trainee: TraineeAdapted }>(),
);

export const resendInvite = createAction(
  '[Trainee Page] Resend Trainee Invite',
  props<{ trainee: TraineeAdapted }>(),
);
export const deleteTrainee = createAction(
  '[Trainee Page] Delete Trainee',
  props<{ trainee: TraineeAdapted }>(),
);

export const downloadCertificate = createAction(
  '[Trainee Page] Download Trainee Certificate',
  props<{ traineeId: string; levelId: number }>(),
);
